@if (flags.loading) {
  <mat-progress-bar mode="indeterminate" [class.iosProgress]="utils.ios()"></mat-progress-bar>
}
<div [style.background-image]="'url(./assets/img/background/' + bgImg + '.jpg)'" class="backgroundCoverFull backgroundFixed">
  <div fxlayout="row" class="interactionsComponent coverDark" [class.ios]="utils.ios()">
    <br />
    <h1>Recent</h1>

    <br />

    @if (interactions?.length == 0 && flags.noResults) {
      <div class="empty animate__animated animate__zoomInUp">
        <p>No interactions to display yet...</p>
        <h3>Love is an act of surrender to another person.</h3>
        <p><a href="https://www.youtube.com/watch?v=3Qptyt0-S9U" target="_blank">- Alan Watts</a></p>
      </div>
    }

    @for (interaction of interactions; track interaction; let i = $index) {
      <div class="interaction" [class.unread]="interaction?.unread || i < unreadCount" [class.lightMode]="!($safeNavigationMigration(interaction?.actor?.color)|isLight)" [style.background]="'linear-gradient(45deg, '+interaction?.actor?.color + '3b'+', #00000082)'">
        @if (interaction.actor.id != user.id) {
          <div [routerLink]="'/' + $safeNavigationMigration(interaction?.actor?.username)" class="profile">
            @if (interaction?.actor?.thumbnail?.sm) {
              <img [src]="$safeNavigationMigration(interaction?.actor?.thumbnail?.sm)" [style.border]="'solid 2px ' + interaction?.actor?.color" />
            }
            @if (!interaction?.actor?.thumbnail?.sm) {
              <div class="noImage" [style.border]="'solid 1px ' + interaction?.actor?.color" [style.color]="interaction?.actor?.color">@if (interaction?.actor?.full_name != '') {
                <span>{{$safeNavigationMigration(interaction?.actor?.full_name)|slice:0:2}}</span>
                }@if (interaction?.actor?.full_name == '') {
                <span>My</span>
              }</div>
            }
            <div class="name"><a [routerLink]="'/'+$safeNavigationMigration(interaction?.actor?.username)">@if (interaction?.actor?.full_name != '') {
              <span>{{ interaction?.actor?.full_name }}</span>
              }@if (interaction?.actor?.full_name == '') {
              <span>Mystrey</span>
            }</a></div>
          </div>
          <!-- {{ interaction?.verb }} -->
          @if (interaction.verb == 'kudos' && interaction.target.object_type == 'accounts.User') {
            <span> gave you Kudos. 🤘</span>
          }
          @if (interaction.verb == 'likes' && interaction.target.object_type == 'accounts.User') {
            <span> is following <a [routerLink]="'/'+$safeNavigationMigration(user?.username)">you</a></span>
          }
          @if (interaction.verb == 'likes' && interaction.target.object_type == 'post.Post') {
            <span> likes your <a [routerLink]="'/'+$safeNavigationMigration(user?.username)+'/'+$safeNavigationMigration(interaction.target?.id)">activity</a></span>
          }
          @if (interaction.verb == 'wrote a comment') {
            <span> commented on your <a [routerLink]="'/'+$safeNavigationMigration(user?.username)+'/'+ $safeNavigationMigration(interaction.target?.id)">activity</a></span>
          }
          <div class="time"> {{ $safeNavigationMigration(interaction?.timestamp)|timeAgo}} ago</div>
        }
      </div>
    }


    @if (flags.loading && resultOffset > 0) {
      <mat-progress-bar mode="indeterminate" class="loadMore"></mat-progress-bar>
    }
  </div>
</div>
